import React, { lazy, Suspense } from 'react';

import LoadingView from '../Interstitial/LoadingView';
import { observer } from 'mobx-react';

const FieldMatchingContainer = lazy(() =>
  import('./components/').then((module) => ({
    default: module.FieldMatchingContainer,
  })),
);

const FieldMatchingView = observer(() => {
  return (
    <Suspense fallback={<LoadingView />}>
      <FieldMatchingContainer />
    </Suspense>
  );
});

export { FieldMatchingView };
